var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.bold ? 'strong' : 'span',{tag:"component",class:[_vm.clazz, { 'ink-link': _vm.clickable }],staticStyle:{"white-space":"nowrap"},on:{"click":_setup.press}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }